module.exports = __webpack_public_path__ + "static/media/control-panel.d9560c91.svg";